import promiseClient from 'hub-http/adapters/promiseClient';
import { createStack } from 'hub-http/index';
import * as core from 'hub-http/middlewares/core';
import * as hubapi from 'hub-http/middlewares/hubapi'; // @ts-expect-error File is not typed

import * as debug from 'hub-http/middlewares/debug'; // This is the `noAuthWithCredentialsHubapi` stack with `core.redirectOnPortalMoved` added

export default promiseClient(createStack(core.services, hubapi.defaults, debug.allowTimeoutOverride, core.jsonBody, core.httpsOnly, hubapi.hubapi, core.withQuery, debug.rewriteUrl, core.reportOptionsError, core.redirectOnPortalMoved, hubapi.retryOnError, core.validateStatus, core.jsonResponse));